export const CARDS_QUERY_KEY = 'cards'
export const CARDS_BRIEFS_QUERY_KEY = 'cardsBriefs'
export const ARCHIVED_CARD_TEMPLATES_QUERY_KEY = 'archivedCards'
export const SUBSCRIPTIONS_QUERY_KEY = 'subscriptions'
export const GIFT_CARDS_QUERY_KEY = 'giftCards'
